import { render, staticRenderFns } from "./play-13.vue?vue&type=template&id=47990903&scoped=true"
import script from "./play-13.vue?vue&type=script&lang=js"
export * from "./play-13.vue?vue&type=script&lang=js"
import style0 from "./play-13.vue?vue&type=style&index=0&id=47990903&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47990903",
  null
  
)

export default component.exports